// Map Constants - Centralized location for all map-related constants
export const DEFAULT_MAP_ZOOM = 17;
export const DEFAULT_MAP_CENTER: google.maps.LatLngLiteral = { lat: 41.8781, lng: -87.6298 };
